
import { ROLES } from "../../types/user.types";
import { UserStoreState } from "./UserStore.types";

export const userStoreState: UserStoreState = {
  token: '',
  role: ROLES.ANY,
  username: '',
  station: '',
}